module.exports = __webpack_public_path__ + "img/stonesLandingHero.75f81cab.jpg";